/**
 * This script created to fix a bug with locksmith when it displayed its' scripts as visible text on JSON template pages.
 * Remove this if they fixed it already (I believe they will fix it until the end of 2021)
 * Any questions? Write me: Alex Mashkovtsev <alex@inso.codes>
 */

$(document).ready(() => {
    const mainContent = document.getElementById('MainContent');
    if (mainContent && mainContent.querySelectorAll("div.custom_page").length > 0 && mainContent.innerHTML.includes("&lt;script data-locksmith&gt;"))
        mainContent.innerHTML = mainContent.innerHTML.replace(/&lt;script data-locksmith&gt;.*?&lt;\/script&gt;/gms, '');
});